import React, { useContext, useState } from "react";
import SimpleContext from "../context/SimpleContext";
import { useHistory } from "react-router";
import config from "../../services/config.json";
import Preloader from "../Preloader/preloader3";
import { browserName, browserVersion } from "react-device-detect";
const LoginWithCode = () => {
  const context = useContext(SimpleContext);
  const history = useHistory();

  //   این بخش برای چک کردن تعداد اعداد وارد شده در بخش احراز هویت است که نهایتا باید 4 عدد باشد.
  function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
      object.value = object.value.slice(0, object.maxLength);
  }
  //لاگین
  const loginUserWithCode = (event) => {
    let MyTime = Date.now();
    let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);

    const myheaders = {
      "atu-token": TimeHeader,
    };
    event.preventDefault();
    context.setpreButton(true);
    async function getData() {
      const url = `${context.baseUrlApiPakhsh}${config.checkPassword}`;
      const formData = new FormData();
      formData.append(
        "customerId",
        Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId
      );
      formData.append("password", context.enterpassUser);
      formData.append("appVersion", browserName);
      formData.append("AndroidVersion", browserVersion);
      formData.append("deviceId", context.UniqueUUID);
      formData.append("appTypeId", context.AppType);
      const param = {
        method: "post",
        body: formData,
        headers: myheaders,
      };
      const sendRequest = await fetch(url, param);
      const response = await sendRequest.json();
      return response;
    }
    try {
      getData().then((data) => {
        context.setpreButton(false);
        if (data.code === 200) {
          context.setpreButton(true);
          context.setIsLoggedIn(true);
          history.push("/");
        } else if (data.code === 400) {
          context.Handelerror(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "100vh",
      }}
    >
      <form onSubmit={loginUserWithCode} className="EnterNumberMAin">
        <div className="registerRow1">
          <img
            alt="image"
            src="/images/CoverBack.jpg"
            className="registerbackground"
            style={{ padding: "0", height: "50vh" }}
          />
          <img alt="image" src="/images/logo.png" className="registerapilogo" />
        </div>

        <div className="registerRow2">
          <div className="registerRow2">
            <div style={{ gap: "15px" }} className="registerRow2Row2">
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  width: "100%",
                }}
                className="infodivUserCode"
              >
                <p
                  style={{
                    margin: "0",
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "14px",
                    display: "flex",
                    justifyContent: "center",
                    width: "95%",
                  }}
                >
                  لطفا رمز عبور خود را وارد کنید
                </p>
              </div>
              <input
                style={{ margin: "0" }}
                placeholder="رمز عبور"
                className="inputPhone"
                oninput={() => maxLengthCheck()}
                // نهایتا تا 11 عدد میتوان وارد کرد.
                onChange={(e) => {
                  context.setenterpassUser(e.target.value);
                }}
              />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  textAlign: "center",
                  alignItems: "center",
                  height: "30px",
                }}
                className="infodivUserCode"
              >
                <p
                  onClick={() => history.push("/userCode")}
                  style={{
                    margin: "0",
                    fontWeight: "bold",
                    color: "#000",
                    fontSize: "15px",
                    display: "flex",
                    justifyContent: "center",
                    width: "95%",
                    color: "#ff7014",
                  }}
                >
                  ورود با کد پیامکی
                </p>
              </div>
            </div>
            {/* اگر تعداد ارقام کمتر از 11 بود، دکمه ثبت و ادامه غیرفعال میشود در غیراینصورت اگر 11 عدد وارد شد، دکمه فعال خواهد شد. */}
            {context.preButton === true ? (
              <button type="button" className="EnterNumberButtonActivated">
                <Preloader />
              </button>
            ) : (
              <button type="submit" className="EnterNumberButtonActivated">
                تایید و ادامه
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginWithCode;
